import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import MultiSelect from "../../../../../../components/select/main/multi/MultiSelect";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../helpers/EVAApiHelper";

function ParkingLocationFormView({
  relations,
  selectedStep,
  selectedStepIndex,
  onParkingLocationsChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <InputWrapper
      label={translate(
        "eva.main.validation.attributes.steps.*.parking_locations",
      )}
      required
      error={EVAApiHelper.getResponseErrorArray(
        `steps.${selectedStepIndex}.parking_locations`,
        submitError,
      )}
    >
      <MultiSelect
        value={selectedStep.parking_locations}
        onChange={onParkingLocationsChange}
        options={relations?.parking_locations?.records?.map((pl) => ({
          value: pl.id,
          label: pl.name,
        }))}
      />
    </InputWrapper>
  );
}

export default ParkingLocationFormView;
